import { Indicator } from "../../types/Indicator/Indicator";
import { errorColor, successColor } from "../../utils/colors";
import { Text } from "@chakra-ui/react";

const getReferenceTextHelper = (indicator: Indicator) => {
  if (!indicator?.reference) {
    return "-";
  }

  const metricName =
    indicator.metric.id === 4 ? indicator.anotherMetric : indicator.metric.name;

  let healthyReference = indicator?.reference?.healthyGreaterValue
    ? `${indicator?.reference?.healthySymbol?.name} ${indicator?.reference?.healthyGreaterValue}`
    : null;

  if (indicator?.reference?.healthyLesserValue) {
    healthyReference += ` e ${indicator?.reference?.healthyLesserValue}`;
  }

  let unhealthyReference = indicator?.reference?.unhealthyGreaterValue
    ? `${indicator?.reference?.unhealthySymbol?.name} ${indicator?.reference?.unhealthyGreaterValue}`
    : null;

  if (indicator?.reference?.unhealthyLesserValue) {
    unhealthyReference += ` e ${indicator?.reference?.unhealthyLesserValue}`;
  }

  return (
    <>
      <Text as="span" color={successColor}>
        {`Saudável (${healthyReference} ${metricName})` || "-"}
      </Text>
      {healthyReference && unhealthyReference && " | "}
      <Text as="span" color={errorColor}>
        {`Não Saudável (${unhealthyReference} ${metricName})` || "-"}
      </Text>
    </>
  );
};

export default getReferenceTextHelper;
